export const CONSTANTS = {
  SET_APP_OPENED_IN_POPUP: '@app/SET_APP_OPENED_IN_POPUP',
  SET_PAYMENT_POPUP: '@app/SET_PAYMENT_POPUP',
  GET_CONFIG: '@app/GET_CONFIG',
  GET_OPTIONS: '@app/GET_OPTIONS',
  SET_FIELD: '@app/SET_FIELD'
};

export default CONSTANTS;
